/* ============================================================
   SAJ · CLIENT REVIEW FIXES — "Website Final Check" (Aug 2026)
   Loaded from snippets/saj-head.liquid.

   Every routine here is defensive and idempotent: if the equivalent
   Liquid-level fix is already present on the page, the routine detects
   that and does nothing. So this file stays safe once the matching
   section/snippet edits are pushed.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sajFixes) return;
  window.__sajFixes = true;

  /* ---------- C1 · quick "Add to cart" on product cards ----------
     snippets/saj-card.liquid renders [data-saj-quickadd="<variant id>"]
     in place of the old eye / quick-view icon. This is its handler. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-saj-quickadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-saj-quickadd');
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        if (window.SAJ && SAJ.refreshCart) SAJ.refreshCart(true);
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
  });

  /* ---------- A6 (partial) · flag Menaxi / silver pages ----------
     Gives page content the green accents. The menu swap itself lives in
     sections/saj-header.liquid; this only handles the theming half. */
  var MENAXI = ['silver', 'menaxi', 'exclusive-silver-collection', 'silver-jewellery', 'silver-utensils', 'pooja-items'];
  function flagMenaxi() {
    var root = document.documentElement;
    if (root.classList.contains('saj-menaxi-page')) return; // Liquid already set it
    var path = (location.pathname || '').toLowerCase();
    var hit = MENAXI.some(function (h) {
      return path.indexOf('/collections/' + h) === 0 || path === '/pages/' + h;
    });
    // Direct /products/<handle> hits carry no collection in the URL. saj-product.liquid
    // already decides silver vs gold and stamps the hallmark badge, so reuse that verdict.
    if (!hit && path.indexOf('/products/') === 0) {
      var badge = document.querySelector('.gal4-badges .gb b, .gal4-seal');
      hit = !!(badge && /sterling|92\.5|925/i.test(badge.textContent || ''));
    }
    if (hit) root.classList.add('saj-menaxi-page');
  }
  flagMenaxi();

  /* ---------- A3 · highlight the nav item for the current section ---------- */
  function markActiveNav() {
    var row = document.querySelector('.saj-header .saj-nav-row');
    if (!row || row.querySelector('li.is-on')) return; // Liquid already did it
    var path = location.pathname.replace(/\/$/, '');
    if (!path) return;
    Array.prototype.forEach.call(row.children, function (li) {
      if (li.classList.contains('saj-allcat')) return; // permanent pill, never "current"
      var links = li.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        var href = (links[i].getAttribute('href') || '').replace(/\/$/, '');
        if (href && href !== '/' && (path === href || path.indexOf(href + '/') === 0)) {
          li.classList.add('is-on');
          var top = li.querySelector(':scope > a');
          if (top) top.setAttribute('aria-current', 'page');
          return;
        }
      }
    });
  }
  markActiveNav();

  /* ---------- A6 · Menaxi pages must show the Menaxi menu ----------
     sections/saj-header.liquid only swaps to the silver menu on the Menaxi
     landing template, so Menaxi collection and product pages kept the Sri Anu
     gold menu (Customization, Gold, Diamonds, Bridal...).
     Here we lift the real nav markup off /pages/menaxi and drop it in, so the
     menu always matches whatever the 'silver-menu' link list actually holds.
     Cached per session; a no-op once the Liquid-level swap is pushed. */
  var MX_SRC = '/pages/menaxi';
  function swapMenaxiNav() {
    if (!document.documentElement.classList.contains('saj-menaxi-page')) return;
    if (location.pathname.replace(/\/$/, '') === MX_SRC) return; // already the source page
    var row = document.querySelector('.saj-header .saj-nav-row');
    var drawer = document.querySelector('.saj-header .dr2-nav');
    if (!row) return;
    // If the gold-only items are absent, the silver menu is already rendered.
    if (!/Customization|Diamonds|Gold Scheme/i.test(row.textContent)) return;

    function apply(navHtml, drawerHtml) {
      if (navHtml) row.innerHTML = navHtml;
      if (drawer && drawerHtml) drawer.innerHTML = drawerHtml;
      markActiveNav();
    }

    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('sajMxNav') || 'null'); } catch (e) {}
    if (cached && cached.nav) { apply(cached.nav, cached.drawer); return; }

    fetch(MX_SRC, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('menaxi nav fetch failed'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var srcRow = doc.querySelector('.saj-header .saj-nav-row');
        if (!srcRow) return;
        var srcDrawer = doc.querySelector('.saj-header .dr2-nav');
        var payload = { nav: srcRow.innerHTML, drawer: srcDrawer ? srcDrawer.innerHTML : '' };
        try { sessionStorage.setItem('sajMxNav', JSON.stringify(payload)); } catch (e) {}
        apply(payload.nav, payload.drawer);
      })
      .catch(function () { /* leave the existing menu in place */ });
  }
  swapMenaxiNav();

  /* ---------- D2 · "Only 1 left" (drop the trailing tagline) ---------- */
  function trimScarcity() {
    document.querySelectorAll('[data-saj-scarce]').forEach(function (el) {
      var n = el.querySelector('[data-saj-scarce-n]');
      if (!n) return;
      var node = n.nextSibling;
      while (node) {
        var next = node.nextSibling;
        if (node.nodeType === 3 && /[—–-]/.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/\s*[—–-]\s*.*$/, '');
        }
        node = next;
      }
    });
  }

  /* ---------- F1 · real WhatsApp glyph instead of the 🟢 emoji ---------- */
  var WA_PATH = 'M12 2a10 10 0 00-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2s-1.2.2-3.9-.9-4.3-3.9-4.5-4.1-1-1.4-1-2.6.6-1.8.9-2 .6-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.6-.3.3c-.2.2-.4.4-.2.7s.8 1.3 1.7 2.1c1.2 1 2.1 1.4 2.4 1.5s.5.1.7-.1l.8-1c.2-.3.4-.2.7-.1l2 1c.3.1.5.2.6.3.1.3.1.7-.1 1.2z';
  function fixWhatsAppIcon() {
    document.querySelectorAll('.btn-wa').forEach(function (a) {
      if (a.querySelector('.wa-ic')) return;
      if (a.textContent.indexOf('🟢') === -1) return;
      var label = a.textContent.replace('🟢', '').trim();
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'wa-ic');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', WA_PATH);
      svg.appendChild(p);
      a.textContent = '';
      a.appendChild(svg);
      a.appendChild(document.createTextNode(label));
    });
  }

  /* ---------- Item 3 · "Making Charges" reads "Value Addition" ----------
     Supersedes the earlier D6 fix, which hid the row entirely and left the
     breakup not adding up to the total. The row is back, renamed. */
  function labelValueAddition() {
    var cell = document.getElementById('labor-cost');
    if (!cell) return;
    var row = cell.closest('tr');
    if (!row) return;
    row.style.removeProperty('display');
    var label = row.querySelector('td');
    if (label && label !== cell && /making\s*charge/i.test(label.textContent || '')) {
      label.textContent = 'Value Addition';
    }
  }

  /* ---------- D7 / item 8 · stone weight units ----------
     The pricing app puts EVERY stone — diamond and coloured alike — into
     #diamond-table; #gemstone-table stays empty. So the unit has to be
     decided per row, not per table:
       · diamond rows keep carats — how diamond is sold, and the client's
         August request ("0.29ct");
       · coloured stones (pearl, emerald, ruby…) read in grams — the client's
         July request.
     1 carat = 0.2 g. The header stays a plain "Total Weight" because the
     column now carries a unit in each cell. */
  function stoneWeightUnits() {
    ['diamond-table', 'gemstone-table'].forEach(function (id) {
      var t = document.getElementById(id);
      if (!t || t.dataset.sajUnits === '1') return;
      var rows = t.querySelectorAll('tbody tr');
      if (!rows.length) return;
      Array.prototype.forEach.call(rows, function (tr) {
        var cells = tr.querySelectorAll('td');
        if (cells.length < 2) return;
        if (/diamond/i.test(cells[0].textContent || '')) return;   // carats stay
        var w = cells[cells.length - 1];
        var m = (w.textContent || '').match(/([\d.]+)\s*Ct\.?\s*(.*)$/i);
        if (!m) return;
        var rest = (m[2] || '').trim();
        w.textContent = (parseFloat(m[1]) * 0.2).toFixed(3) + ' g' + (rest ? ' ' + rest : '');
      });
      // the app rewrote the header on the earlier pass — put it back
      Array.prototype.forEach.call(t.querySelectorAll('thead th'), function (th) {
        if (/total weight \(g\)/i.test(th.textContent || '')) th.textContent = 'Total Weight';
      });
      t.dataset.sajUnits = '1';
    });
  }

  /* ---------- run now, and again whenever the app re-renders ---------- */
  function runAll() {
    trimScarcity();
    fixWhatsAppIcon();
    labelValueAddition();
    stoneWeightUnits();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  var host = document.getElementById('product-details-tab') || document.body;
  if (window.MutationObserver && host) {
    var mo = new MutationObserver(function () { runAll(); });
    mo.observe(host, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); runAll(); }, 15000);
  }
})();
